import http from '@/utils/http';

// 登录
export const getSession = (data) => {
    return http({
        url: '/api/ca/v2/session/lp',
        method: 'post',
        data: data
    });
};
// 获取量表基础表列表
export const scaleList = (params) => {
    return http({
        url: '/api/adhd/v2/scale/list',
        params
    });
};
// 64位
export const baseList = (id) => {
    return http({
        url: `/api/oss/v2/file/base64?fileId=${id}`,
    });
};

// 总答案
export const scaleAnswerList = (params) => {
    return http({
        url: '/api/adhd/v2/scaleAnswer/list',
        params
    });
};

// 提交答案
// export const getScaleAnswer = (data) => {
//     return http({
//         url: '/api/adhd/v2/scaleAnswer',
//         method: 'post',
//         data: data
//     });
// };
// 修改答案
export const editScaleAnswer = (data) => {
    return http({
        url: '/api/adhd/v2/scaleAnswer',
        method: 'post',
        data: data
    });
};
//获取下次的答题的次数
export const scaleAnswerNextTimes = (id) => {
    return http({
        url: `/api/adhd/v2/scaleAnswer/nextTimes?studentId=${id}`,
    });
};




// 获取总分
export const getScore = (id) => {
    return http({
        url: `/api/adhd/v2/scaleAnswer/score?studentId=${id}`,
        // url: '/api/adhd/v2/scaleAnswer/score',
    });
};
// 获取学校表列表
export const schoolList = (params) => {
    return http({
        url: '/api/rongai/v2/school/list',
        params
    })
}
//获取量表答题进度
export const getSchedule = (params) => {
    return http({
        url: '/api/adhd/v2/scaleAnswerSchedule/getSchedule',
        params
    })
}
// 获取当前答题次数
export const currentTimes = (id) => {
    return http({
        url: `/api/adhd/v2/scaleAnswer/currentTimes?studentId=${id}`,
    })
}

// 修改量表答题进度表
export const updaScaleAnswerSchedule = (data) => {
    return http({
        url: '/api/adhd/v2/scaleAnswerSchedule',
        method: 'post',
        data: data
    });
};
//获取当前量表已选数据
export const getScaleAnswerData = (params) => {
    return http({
        url: '/api/adhd/v2/scaleAnswer/scaleAnswerData',
        params
    })
}